import React from 'react'
import { Link } from 'react-router-dom'
import { Skeleton } from '../Skeleton/Skeleton'

import './PageHeader.css'

/**
 * 
 * @param {*} props 
 * @returns 
 */
export function PageHeader(props) {

  return (
	<div className="content-header">
        {
            props?.isLoading === true 
            ? <>
                <h1><Skeleton width={100} height={18}/></h1>
                <div><Skeleton width="60%" height={18}/></div>
            </>
            : (<>

                { props.title && <h1 className={props.description ? 'mb-10' : ''}>{props.title}</h1>}
                { props.actionBtns && props.actionBtns.length > 0 && 
                    <div className='header-btns'>
                        {

                            props.actionBtns.map( (item , index) => {
                                return (
                                    item?.type === 'component'
                                    ? <React.Fragment key={`header-action-btns-${index}`}>{item?.component}</React.Fragment>
                                    : <Link key={`header-action-btns-${index}`} className={`btn btn-${item?.color ?? 'purple'}`} to={item?.link}>{item?.name}</Link>
                                )
                            })
                        }
                    </div>
                }
                { props.description && <p>{props.description}</p>}
                </>
            )
        }
	</div>
  )
}
